import { ENDPOINT_OPAL_EXPLICITFITS } from 'apis/opal';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { updateExplicitFits } from 'apis/mafia';
import { trackError } from 'helpers/ErrorUtils';
import { setPageContentDynamicValues } from 'actions/dynamicPageContentValues';
import { fetchProductDetail } from 'actions/productDetail';

import css from 'styles/components/landing/fitSurveyContent.scss';

// ENDPOINT_OPAL_EXPLICITFITS
const setDynamicValuesForFit = (dispatch, getState, { orderId, asin }) => response => {
  let productInfo = 'item';
  return Promise.resolve(response)
    .then(response => {
      // We hope that the first name is already stored in the Holmes cookie.
      const { holmes = {} } = getState();
      const holmesFirstName = holmes.firstName;
      const firstName = holmesFirstName && `, ${holmesFirstName}` || '';

      if (response && response.fit) {
        let reviewThisItem = '';
        let returnThisItem = '';

        // The fit has almost everything we need to display back to the customer.
        // It has a productId; and with it, we can retrieve the brand and the actual product name.
        const { fit: { productId, size } } = response;
        if (productId) {
          return dispatch(fetchProductDetail(productId, { errorOnOos: false }))
            .then(response => {
              const { brandName, productName } = response;
              const inSize = (size) ? ` in ${size}` : '';
              productInfo = `${brandName}, ${productName}${inSize}`;
              reviewThisItem = `<a class="${css.fsCtaLink}" href="/product/review/add/${productId}">Leave a review</a>`;
              returnThisItem = orderId && `<a class="${css.fsCtaLink}" href="/returnInitiate?orderId=${orderId}&useComet=true&asin=${asin}">Return this item</a>` || '';
            })
            .then(() => {
              // If Marty finds a DynamicPageContent component with a 'fitsurvey' templatetype value,
              // it will use the values specified here to fill out the template placeholders.
              dispatch(setPageContentDynamicValues({ fitsurvey: { firstName, productInfo, reviewThisItem, returnThisItem } }));
            });
        }
      }
      dispatch(setPageContentDynamicValues({ fitsurvey: { productInfo } }));
    })
    .catch(e => {
      dispatch(setPageContentDynamicValues({ fitsurvey: { productInfo } }));
      trackError('NON-FATAL', 'Could not update already existing fit.', e);
    });
};

export const beaconCustomHandlers = {
  [ENDPOINT_OPAL_EXPLICITFITS]: {
    'shouldFireAndForget': false,
    'post': (dispatch, getState, mafia, data = {},
      {
        doSetDynamicValuesForFit = setDynamicValuesForFit, // For easy testing.
        doUpdateExplicitFits = updateExplicitFits
      } = {}) => response => {

      // We need to update the survey fit.
      // Also, we'll need to grab the info to display back to the customer.
      // e.g.: Customer's first name, brand, product name, and product size.

      let nextAction;

      const { auth_token: emailAuthToken } = data;

      // Did the post request succeed?
      if (response.status === 409) {
        // It didn't.  409 means that the fit already exists, so no need to create it.
        // Let's use PUT to update it.
        // The existing fit id is included in the 'location' response header.
        const locationHeader = response.headers && response.headers.get('location') || '';

        // locationHeader has this format: /auth/explicit/fits/<FIT ID>
        // The regex below essentially says: "match everything after the last slash."
        const fitId = (locationHeader.match(/.*\/fits\/(.+)$/) || [])[1];

        if (fitId) {
          // Set everything to dispatch the PUT.
          nextAction = doUpdateExplicitFits(mafia, fitId, data, emailAuthToken);
        } else {
          trackError('NON-FATAL', 'Could not extract fit.');
          dispatch(setPageContentDynamicValues({ fitsurvey: { productInfo: 'item' } }));
        }
      } else {
        // If we are here, the POST may have succeeded.
        // We'll leave it to fetchErrorMiddleware to figure it out.
        nextAction = Promise.resolve(response);
      }

      // If either the POST or PUT succeeds, we proceed to set the contextual
      // data to display back to the customer (as we mentioned at the top.)

      return nextAction &&
        nextAction
          .then(fetchErrorMiddleware)
          .then(doSetDynamicValuesForFit(dispatch, getState, data));
    }
  }
};

/**
 * contentBeaconMiddleware - inspects fetch response for custom beacon impression error cases.
 * If there are no matching beacon impression error case handlers, will transfer inspection
 * to fetchErrorMiddleware
 *
 * @return {function}  the custom error inspector and handler - or fetchErrorMiddleware
 *
 * beaconCustomHandlersList is used during testing.
 *
 */
export function contentBeaconMiddleware(dispatch, getState, mafia, beaconData, endpoint, method = 'get', beaconCustomHandlersList = beaconCustomHandlers) {
  const { [method]: beaconCustomHandler } = beaconCustomHandlersList[endpoint] || {};
  return (
    (typeof(beaconCustomHandler) === 'function') &&
     beaconCustomHandler(dispatch, getState, mafia, beaconData) ||
    fetchErrorMiddleware
  );
}
